import {
  Button,

  Input,
  Modal,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import MDBox from "components/MDBox";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import { axiosClient } from "Api/axoisClient";
import Swal from "sweetalert2";
import LoadingCom from "components/Loading/LoadingCom";
import { useTranslation } from "react-i18next";
import { useMaterialUIController } from "context";

const BrochureModal = ({ open, setOpen, plan, action, setReload }) => {
  const { t } = useTranslation();
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const [planInfo, setPlanInfo] = useState({
    id: plan?.id || "",
    image: plan?.image || "",
    type: plan?.type || "",
    max_company_brochures: plan?.max_company_brochures || 0,
    max_announcement_brochures: plan?.max_announcement_brochures || 0,
  });
  const [errors, setErrors] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);

  const hundelChange = async (e) => {

    setPlanInfo((pre) => {
      return {
        ...pre,
        [e.target.name]: e.target?.value || null,
      };
    });
  };


  const updatePlan = async (e, id) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await axiosClient.put(`/plans/${id}/updateBrochure`, planInfo);

      if (res.status === 200) {
        setErrors([]);
        Swal.fire({
          icon: "success",
          title: t("plans.messages.updateSuccess"),
        });
        setReload((pre) => !pre);
        setOpen(false);
      }
    } catch (err) {
      if (err?.response?.status === 422) {
        setErrors(
          Object.values(err?.response?.data).map((item) => {
            return item[0];
          })
        );
      } else {
        setErrors([t("plans.messages.error.tryAgain")]);
      }
    }
    setIsLoading(false);
  };

  const createPlan = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const res = await axiosClient.post(`/plans`, planInfo);

      if (res.status === 200) {
        setErrors([]);
        Swal.fire({
          icon: "success",
          title: t("plans.messages.createSuccess"),
        });
        setReload((pre) => !pre);
        setOpen(false);
      }
    } catch (err) {
      if (err?.response?.status === 422) {
        setErrors(Object.values(err?.response?.data));
      } else {
        setErrors([t("plans.messages.error.tryAgain")]);
      }
    }
    setIsLoading(false);
  };


  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      sx={{
        zIndex: "999 !important",
        bgcolor: "#0000004f",
      }}
      aria-describedby="modal-modal-description"
    >
      <Box sx={{bgcolor: !darkMode ? "#fbfcfd" : "#202940"}} className="absolute top-[50%] left-[55%] w-[98%] sm:w-[70%] lg:w-[50%] rounded-lg shadow-lg -translate-y-[50%] -translate-x-[50%]">
        <MDBox
          className="flex justify-between rounded-t-lg p-5"
          variant="gradient"
          bgColor="info"
        >
          <Typography
            sx={{ color: "white !important" }}
            id="modal-modal-title"
            variant="h5"
            component="h2"
          >
            {action === "create" ? t("plans.title.create") : "Update Brochure"}
          </Typography>
          <CloseIcon
            onClick={() => setOpen(false)}
            className="text-white cursor-pointer"
          />
        </MDBox>
        <Box id="modal-modal-description" className="p-5 h-[65vh] hide-scrollbar overflow-y-scroll flex gap-y-8 flex-col">
          {IsLoading ? (
            <LoadingCom />
          ) : (
            <>
              {errors?.length > 0 && (
                <Box className="p-2 text-white flex flex-col rounded-lg bg-red-500">
                  {errors?.map((item, index) => (
                    <Typography fontSize={16} key={index} component="body2">
                      {item}
                    </Typography>
                  ))}
                </Box>
              )}

              <Box className="flex items-center gap-3">
                <Typography
                  className="w-1/4"
                  sx={{ fontWeight: 500, fontSize: "16px" }}
                  component="body2"
                >
                  {t("plans.labels.badge")}
                </Typography>
                <Typography className="w-3/4" component="body2">
                  {planInfo.image ? (
                    <img
                      src={planInfo.image || null}
                      alt={planInfo.type || "Default plan"}
                      className="w-[40px] h-[40px]"
                    />
                  ) : (
                    <p className="text-[16px]">{t("plans.labels.noImage")}</p>
                  )}
                </Typography>
              </Box>

              <Box className="flex items-center gap-3">
                <Typography
                  className="w-1/4"
                  sx={{ fontWeight: 500, fontSize: "16px" }}
                  component="body2"
                >
                  {t("plans.labels.type")}
                </Typography>
                <Typography
                  className="w-3/4" >
                    {planInfo?.type}
                </Typography>
              </Box>

              <Box className="flex flex-col md:flex-row items-center gap-3">
                <Typography
                  className="w-full md:w-2/4"
                  sx={{ fontWeight: 500, fontSize: "16px" }}
                  component="body2"
                >
                  {"Fiches de Présentation des Entreprises"}
                </Typography>
                {console.log(planInfo)}
                <Input
                  value={planInfo?.max_company_brochures}
                  onChange={(e) => hundelChange(e)}
                  className="w-full md:w-2/4"
                  name="max_company_brochures"
                  type="number"
                ></Input>
              </Box>
              <Box className="flex flex-col md:flex-row items-center gap-3">
                <Typography
                  className="w-full md:w-2/4"
                  sx={{ fontWeight: 500, fontSize: "16px" }}
                  component="body2"
                >
                  {"Fiches des Annonces"}
                </Typography>
                <Input
                  value={planInfo?.max_announcement_brochures}
                  onChange={(e) => hundelChange(e)}
                  className="w-full md:w-2/4"
                  name="max_announcement_brochures"
                  type="number"
                ></Input>
              </Box>



              <Box className="flex justify-center">
                {action === "create" && (
                  <Button
                    onClick={(e) => createPlan(e)}
                    disabled={IsLoading}
                    variant="contained"
                    bgColor="info"
                    sx={{ color: "#ffffff" }}
                  >
                    {t("plans.buttons.create")}
                  </Button>
                )}

                {action === "update" && (
                  <Button
                    onClick={(e) => updatePlan(e, planInfo?.id)}
                    variant="contained"
                    disabled={IsLoading}
                    bgColor="info"
                    sx={{ color: "#ffffff" }}
                  >
                    {t("plans.buttons.update")}
                  </Button>
                )}
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default BrochureModal;
